const style = (theme) => {
  const output = {
    root: {
      minHeight: '100%',
      color: theme.colors[1],
    },
    wrapper: {
      extend: theme.wrapper,
      display: 'flex',
    },
    wrapperSpacingVertical: {
      paddingTop: 180,
      paddingBottom: 180,
    },
    wrapperColumn: {
      flexDirection: 'column',
    },
    wrapperRoll: {
      overflowX: 'hidden',
    },
    rollContent: {
      position: 'relative',
    },
    rollImg: {
      width: '20vw',
    },
    rollCta: {
      marginTop: 40,
    },
    rollTitle: {
      position: 'absolute',
      top: '50%',
      left: '10%',
      transform: 'translateY(-50%)',
      fontFamily: theme.fonts[1],
      color: theme.colors[4],
      textTransform: 'uppercase',
    },
    parallaxText: {
      color: theme.colors[4],
    },
  }

  /*------------------------------
  MD
  ------------------------------*/
  output[theme.mediaInverse.md] = {
    rollImg: {
      width: '30vw',
    },
    wrapperSpacingVertical: {
      paddingTop: 120,
      paddingBottom: 120,
    },
  }

  /*------------------------------
  SM
  ------------------------------*/
  output[theme.mediaInverse.sm] = {
    wrapper: {
      flexDirection: 'column',
    },
    rollImg: {
      width: '40vw',
    },
  }

  return output
}

export default style
